unit UInstanceList;

interface

uses
  System.Contnrs, UInstanceModel, UEssentialHelper;

type
  TInstanceList = class(TObjectList)
  private
    FOnPropertyChanged: TCallback;
    function GetItem(i: Integer): TInstanceModel;
    procedure PropertyChanged;
    procedure SetValues(json: string);
    procedure SetOnPropertyChanged(const Value: TCallback);
  public
    procedure Add(item: TInstanceModel);
    procedure GetAll(url: string; id: Integer);
    property Items[i: Integer]: TInstanceModel read GetItem;
    property OnPropertyChanged: TCallback read FOnPropertyChanged write SetOnPropertyChanged;
  end;

implementation

uses
  WebLib.JSON, WebLib.REST, System.SysUtils, Js;

{ TInstanceList }

procedure TInstanceList.Add(item: TInstanceModel);
begin
  inherited Add(item);
end;

procedure TInstanceList.GetAll(url: string; id: Integer);
var obj: TJsonObject;
    helper: string;
    client: TRestClient;
  procedure Response(Sender: TObject; AResponse: string);
  var jso: TJsObject;
  begin
    jso:=TJsJson.parseObject(AResponse);
    if jso['value']<>nil then
      Self.SetValues(string(jso['value']));
    Self.PropertyChanged;
  end;
begin
  obj:=TJsonObject.Create;
  obj.AddPair('Id',IntToStr(id));
  helper:=obj.ToString;
  obj:=TJsonObject.Create;
  obj.AddPair('value',helper);
  client:=TRestClient.Create(nil);
  client.OnResponse:=Response;
  client.HttpsPost(url+'/HolidayService/GetAllInstances','application/json',obj.ToString);
  client.Free;
end;

function TInstanceList.GetItem(i: Integer): TInstanceModel;
begin
  Result:=inherited GetItem(i) as TInstanceModel;
end;

procedure TInstanceList.PropertyChanged;
begin
  if Assigned(Self.OnPropertyChanged) then
    Self.OnPropertyChanged(Self);
end;

procedure TInstanceList.SetOnPropertyChanged(const Value: TCallback);
begin
  FOnPropertyChanged := Value;
end;

procedure TInstanceList.SetValues(json: string);
var obj: TJsObject;
    i, count: Integer;
begin
  Self.Clear;
  obj:=TJsJson.parseObject(json);
  if obj['Count']<>nil then begin
    count:=StrToInt(string(obj['Count']));
    for i:=0 to count-1 do
      if obj['Item'+IntToStr(i)]<>nil then
        Self.Add(TInstanceModel.Create(string(obj['Item'+IntToStr(i)])));
  end;

end;

end.
